// src/utils/carePlanItems.js
//
// Shared filtering for a patient's GET /patients/{id}/care-plan response —
// test runs (automated and manual) write action items against real patient
// records and tag them "[TEST]", and a doctor note can be saved with no
// actual text. Neither is something a patient should see or have counted
// against them, so every screen that shows a care-plan item or an "open
// items" count filters through this first — PatientCarePlanPage.jsx (the
// Open/Done/Total stats and the list itself) and patientSummary.js (whose
// openActionItems feeds the Today screen's attention banner) used to filter
// independently, which let them disagree on the count for the same patient.

const TEST_ITEM_MARKER = /\[TEST\]/i;

export const isTestItem = item => TEST_ITEM_MARKER.test(item?.description || '');

// A doctor note with no actual text — item.description empty/whitespace
// only — has nothing for the patient to read or act on. Scoped to DOCTOR
// specifically: a blank navigator/AI item would be a real bug worth
// surfacing, not boilerplate to hide.
export const isBlankDoctorNote = item =>
  item?.authorRole === 'DOCTOR' && !item?.description?.trim();

export function filterCarePlanItems(items) {
  return Array.isArray(items) ? items.filter(i => !isTestItem(i) && !isBlankDoctorNote(i)) : [];
}
